var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 18,
    viewBox: "0 0 206 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.662 18L17.2249 3.50581L3.81213 18H0L16.9086 0H19.4076L26.5268 18H22.662V18Z",
    fill: "#0A84FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0024 18L31.9815 3.26599H34.7835L30.8044 18H28.0024V18Z",
    fill: "#0A84FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.757 18L46.053 11.4288H38.2311L36.4568 18H33.6548L37.6338 3.26599H50.2428C53.6158 3.26599 54.5117 4.70931 53.9408 6.82413L53.6597 7.87064C53.1458 9.77617 51.7448 11.1366 49.0438 11.3852L50.7567 18H47.757V18ZM51.1388 6.80233C51.3759 5.92151 50.9148 5.44186 49.6499 5.44186H39.8473L38.8196 9.25291H48.6222C49.8871 9.25291 50.6073 8.77326 50.8445 7.89245L51.1388 6.80233V6.80233Z",
    fill: "#0A84FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6258 18V6.64535L72.1275 18H68.6755L60.1246 6.67151V18H56.2378V0H60.1509L70.5816 13.936L80.9332 0H84.5126V18H80.6258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4155 18V3.26599H103.059V5.92588H90.8544V8.87791H102.409V11.5552H90.8544V15.3227H103.059V18H87.4155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.063 18V5.92151H104.408V3.26163H123.003V5.92151H115.519V18H112.063V18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.468 18V11.5509H128.168V18H124.733V3.26599H128.168V8.87791H139.468V3.26599H142.924V18H139.468Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.507 18L155.318 6.78053L147.979 18H144.141L154.027 3.26599H156.556L166.381 18H162.503H162.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.074 18L170.619 7.26018V18H167.624V3.26599H170.597L184.743 13.3561V3.26599H187.756V18H186.07H186.074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.356 18V3.26599H206V5.92588H193.795V8.87791H205.35V11.5552H193.795V15.3227H206V18H190.356Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/HeaderLogo.a05954918d3ca8591f28d7000da95d8c.svg";
export { ForwardRef as ReactComponent };